import './HandleContainer.css'
import { Handle } from '../handle/Handle'

export const HandleContainer = () => {
  return (
    <div className='handleContainer'>
      <Handle />
    </div>
  )
}